
import Vue from 'vue';
import { Button, Icon, Modal } from '@descomplica/vue-components';
import { TranslateResult } from 'vue-i18n';
import { Route } from 'vue-router';

interface Data {
  width: number;
  isCopied: boolean;
  isActive: boolean;
}
export default Vue.extend({
  components: {
    Button,
    Icon,
    Modal,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
  data(): Data {
    return {
      width: window.innerWidth,
      isCopied: false,
      isActive: this.active,
    };
  },
  computed: {
    getDeviceImg(): string {
      let device = 'desktop';
      if (this.width < 768) {
        device = 'mobile';
      }
      if (this.width >= 768 && this.width < 1287) {
        device = 'tablet';
      }
      return `${process.env.BASE_URL || ''}img/trial/couponModal/${device}-ilustration.svg`;
    },
    getCoupon(): TranslateResult {
      return this.$t('trial.showCase.modals.showcase.coupon.couponValue');
    },
    copyFeedback(): TranslateResult {
      return this.isCopied
        ? this.$t('trial.showCase.modals.showcase.coupon.copiedCoupon')
        : this.$t('trial.showCase.modals.showcase.coupon.copyCoupon');
    },
  },
  watch: {
    $route(to) {
      (this as any).showCaseOpenCouponModal(to);
    },
  },
  mounted() {
    window.addEventListener('resize', this.getDimensions);
    (this as any).showCaseOpenCouponModal(this.$router.currentRoute);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getDimensions);
  },
  methods: {
    onCloseClick() {
      this.isActive = false;
    },
    onClickSelectiveProcessButton(): void {
      window.open(this.$t('trial.showCase.selectiveProcessUrl') as string);
    },
    getDimensions(): void {
      this.width = window.innerWidth;
    },
    copyHandler(): void {
      this.isCopied = true;
      navigator.clipboard.writeText(this.getCoupon as string);

      const { setTimeout } = window;
      setTimeout(() => {
        this.isCopied = false;
      }, 2000);
    },
    showCaseOpenCouponModal(to: Route): void {
      if (to?.query?.openCoupon === 'open') {
        this.$data.isActive = true;
        const query = { ...this.$route.query };
        delete query.openCoupon;
        this.$router.replace({ query });
      }
    },
  },
});
